import { BackgroundColor } from '@/constants/enum';
import colorString from 'color-string';

export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export function uniq(a: Array<any>) {
  return Array.from(new Set(a));
}

export const stringify = (input: any) => {
  return JSON.stringify(input);
};

export const isValidColor = (color: string, defaultColor: BackgroundColor) => {
  if (color) {
    return colorString?.get(color) !== null ? color : defaultColor;
  } else {
    return defaultColor;
  }
};

export const validatePositiveIntegerInput = (value: string) => {
  // Loại bỏ dấu '-' nếu có trong chuỗi đầu vào

  value = value.replace(/-/g, '');

  const isValidNumber = /^[0-9]\d*$/.test(value); // Chỉ cho phép số nguyên dương

  if (isValidNumber) {
    let numericValue = parseInt(value, 10);

    value = numericValue.toString();
  } else {
    value = '';
  }

  return value;
};

export function extractColor(html: string | null) {
  const regex = /#[0-9a-fA-F]{6}/g;
  const colors = html?.match(regex);

  if (!colors) {
    return undefined;
  }

  // Loại bỏ các màu trùng lặp bằng cách sử dụng Set
  const uniqueColors = [...new Set(colors)];

  // Nếu chỉ có đúng 1 màu duy nhất, trả về màu đó, ngược lại trả về undefined
  return uniqueColors.length === 1 ? uniqueColors[0] : undefined;
}
